import { render } from "./ToolsPanel.vue?vue&type=template&id=4954fb01&scoped=true&ts=true"
import script from "./ToolsPanel.vue?vue&type=script&lang=ts"
export * from "./ToolsPanel.vue?vue&type=script&lang=ts"

import "./ToolsPanel.vue?vue&type=style&index=0&id=4954fb01&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4954fb01"]])

export default __exports__